const config={
    // URL:'https://cors-anywhere.herokuapp.com/api.onegml.com/v1',
    URL:'https://api.onegml.com/v1',
    // URL:'http://testapi.onegml.com/v1',
    USER:'onegmlapi',
    PASS:'O1n6e0G4M7L'
}

export const {URL,USER,PASS}=config